import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
} from "@aws-amplify/ui-react";
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { APadded, NextBackButtonHolder } from "../components/layout";
import { AH2 } from "../components/text";
import { useContext, useEffect } from "react";
import { GlobalContext } from "../context/global";
import styled from 'styled-components';
import { INutritionData } from "../interfaces";

const Table = styled.table`
  width:535px;
  margin-top:20px;
  margin-bottom:20px;
  border-collapse: collapse;
  tr {
    td:not(:first-child) {
      text-align:right;
    }
  }
  thead tr {
    background-color: #FFF;
    color: #000;
    font-weight:bold;
    text-align: left;
  }
  th,td {
    padding: 12px 15px;
  }
  tr {
    border-bottom: 1px solid #dddddd;
  }
  tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
  }
  tbody tr:last-of-type {
    border-bottom: 2px solid #009879;
  }
`

const SimpleLink = styled.a`
  text-decoration:none;
`

const TableContainer = styled(View)`
  max-width:100%;
  overflow-x:scroll;
`

const types = ["saltCapsule", "saltChew", "drink", "bar", "gel"];
const mapping = {
  "saltCapsule" : "saltCapsule",
  "saltChew" : "saltChew",
  "drink" : "drinks",
  "bar" : "bars",
  "gel": "gels",
}

export const ViewEventBasketCheckout = () => {
    const navigate = useNavigate()
    const {nutritionData, basket, userData} = useContext(GlobalContext);
    
    const haveBasket = (nutritionData as any).hasLoaded
    if (!haveBasket) {
      return <Navigate to="/" />
    }
    
    const nutrition = nutritionData as INutritionData;
    
    let basketTotal = 0;
    for (const typ of types) {
        const product = (nutrition.products as any)[typ]
        if (!product) {
          continue;
        }
        const amount = (basket as any)[(mapping as any)[typ]] as number;
        const price = product.priceGBP * amount;
        basketTotal = basketTotal + price;
    }
    const total = basketTotal.toFixed(2);
    
    const checkout = () => {
      let urlFragment = "";
      for (const t of types) {
        const product = (nutrition as any).products[t];
        if (!product) continue;
        urlFragment = urlFragment + `${product.ID}:${(basket as any)[(mapping as any)[t]]},`
      }
      //TODO show a loader if we can or something on the page.
      window.location.href = (`https://2260fd-3.myshopify.com/cart/${urlFragment}?checkout[email]=${userData.user?.email || ''}`)
      //${nutrition.products.saltCapsule.ID}:${basket.saltCapsule},${nutrition.products.saltChew.ID}:${basket.saltChew},${nutrition.products.gel.ID}:${basket.gels},${nutrition.products.bar.ID}:${basket.bars},${nutrition.products.drink.ID}:${basket.drinks}
    }

    const goBack = () => {
      navigate("/event/new/1/basket/water")
    }


    return <APadded>
      <AH2>Your Event Package</AH2>
      <TableContainer>
    <Table>
       <thead>
       <tr><td>Fuel</td><td>Quantity</td><td>Price</td><td>Total</td></tr>
       </thead>
      <tbody>
    <tr><td><b>Fuel (calories</b>)</td><td></td><td></td><td></td></tr>
    { (basket.gels && nutrition.products?.gel) ? <tr><td>{ nutrition.products.gel.description || "Energy Gel"}</td><td>{basket.gels}</td><td>£{nutrition.products.gel.priceGBP}</td><td>£{(basket.gels * nutrition.products.gel.priceGBP).toFixed(2)}</td></tr> : null}
    { (basket.drinks && nutrition.products.drink) ? <tr><td>{ nutrition.products.drink.description || "Drink Mix"}</td><td>{basket.drinks}</td><td>£{nutrition.products.drink.priceGBP}</td><td>£{(basket.drinks * nutrition.products.drink.priceGBP).toFixed(2)}</td></tr> : null }
    { (basket.bars && nutrition.products?.bar) ? <tr><td>{ nutrition.products.bar.description || "Energy Bar"}</td><td>{basket.bars}</td><td>£{nutrition.products.bar.priceGBP}</td><td>£{(basket.bars * nutrition.products.bar.priceGBP).toFixed(2)}</td></tr> : null }
    <tr><td><b>Salt</b></td><td></td><td></td><td></td></tr>
    { (basket.saltChew && nutrition.products.saltChew) ? <tr><td>{ nutrition.products.saltChew.description || "Salt Tabs"}</td><td>{basket.saltChew}</td><td>£{nutrition.products.saltChew.priceGBP}</td><td>£{(basket.saltChew * nutrition.products.saltChew.priceGBP).toFixed(2)}</td></tr> : null}
    { (basket.saltCapsule && nutrition.products.saltCapsule) ? <tr><td>{ nutrition.products.saltCapsule.description || "Salt Tabs"}</td><td>{basket.saltCapsule}</td><td>£{nutrition.products.saltCapsule.priceGBP}</td><td>£{(basket.saltCapsule * nutrition.products.saltCapsule.priceGBP).toFixed(2)}</td></tr> : null}
    <tr><td><strong>TOTAL</strong></td><td></td><td></td><td><strong>£{total}</strong></td></tr>
    </tbody></Table>
    </TableContainer>
    <NextBackButtonHolder>
    <Button onClick={goBack}>
              ‹ Back 
            </Button>&nbsp;
    <Button variation="primary" onClick={checkout}>
        Go to checkout ›
      </Button>
      </NextBackButtonHolder>
    </APadded>
}
// &checkout[shipping_address][first_name]=Tom&checkout[shipping_address][last_name]=Smith add these back in above if we start storing name etc.